import { getOwner } from '@ember/application';
/**
 * Given a record, obtain the ember-data model class
 * @param record
 */
export function _getModelClass(record) {
  return record.constructor;
}

/**
 * Given an ember-data model class, obtain its name
 * @param clazz
 */
export function _getModelName(clazz) {
  return (
    // prettier-ignore
    clazz.modelName // modern use
    // @ts-ignore
    || clazz.typeKey // legacy fallback
  );
}

/**
 * Given an ember-data-record, obtain the related Store
 * @param record
 */
export function _getStoreFromRecord(record) {
  const owner = getOwner(record);
  return owner.lookup('service:store');
}
function snapshotFromRecord(model) {
  return model._createSnapshot();
}

/**
 *
 * @param record
 * @param opPath
 * @param urlType
 * @param instance
 */
export function buildOperationUrl(record, opPath, urlType, instance = true) {
  const modelClass = _getModelClass(record);
  const modelName = _getModelName(modelClass);
  const store = _getStoreFromRecord(record);
  const adapter = store.adapterFor(modelName);
  const path = opPath;
  const snapshot = snapshotFromRecord(record);
  const baseUrl = adapter.buildURL(modelName, instance ? record.get('id') : null, snapshot, urlType);
  if (!path) {
    return baseUrl;
  }
  if (baseUrl.charAt(baseUrl.length - 1) === '/') {
    return `${baseUrl}${path}`;
  } else {
    return `${baseUrl}/${path}`;
  }
}
export default buildOperationUrl;